import * as React from "react";
import { FormRow } from "../../components/FormRow";
import { Input } from "../../components/Input";
import { Select } from "../../components/Select";
import type { Field } from "../types";

interface Props {
  field: Field;
  value: string;
  placeholder?: string;
  onChange: (v: string) => void;
  disabled?: boolean;
}

export function StringField({
  field,
  value,
  placeholder,
  onChange,
  disabled,
}: Props) {
  const hasOptions = (field.options?.length ?? 0) > 0;
  const envHint =
    placeholder && !value
      ? "기본값은 env로 설정되어 있습니다. 입력 시 override 됩니다."
      : null;
  const unitHint = field.unit ? `Unit: ${field.unit}` : null;
  const helpParts = [envHint, unitHint, field.help].filter(
    Boolean,
  ) as React.ReactNode[];
  const help = helpParts.length
    ? helpParts.map((part, i) => (
        <span key={i} className="block">
          {part}
        </span>
      ))
    : undefined;
  return (
    <FormRow
      label={field.title ?? field.key}
      required={field.required}
      help={help}
    >
      {hasOptions ? (
        <Select
          className="max-w-md"
          value={value}
          onValueChange={onChange}
          disabled={disabled}
          placeholder={placeholder ?? "—"}
          options={field.options!.map((o) => ({ label: o, value: o }))}
        />
      ) : (
        <Input
          className="max-w-md"
          type="text"
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
        />
      )}
    </FormRow>
  );
}
